import component from './component';
import { fixtures } from '@content/results';

export default component;

export { component, fixtures };
